import { combineReducers } from "redux";
import activitiesReducer from "./activitiesReducer";
import bankReducer from "./projectsReducer"


const reducers = combineReducers({
    bank: bankReducer,
    activities: activitiesReducer
})

export default reducers

export type RootState = ReturnType<typeof reducers>